export class QualificationsProfessionnelles {

	public precisions: string;

	constructor() { 
		 		this.precisions = '';
 
	}
}
